import { OrderedMap, fromJS } from 'immutable';

import { ADD_MULTIPLE, ADD, UPDATE, REMOVE } from './constants';

const initialState = fromJS({ partners: OrderedMap() });

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_MULTIPLE:
      return state.set('partners', state.get('partners').merge(action.partners));

    case ADD:
    case UPDATE:
      return state.setIn(['partners', action.partner.id], action.partner);

    case REMOVE:
      return state.deleteIn(['partners', action.partner]);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
